import { Card, CardContent } from './ui/card';

/**
 * Shared white "phrase card" shell used by both practice modes (Manual +
 * Automatic) so the card styling and padding live in ONE place — change them
 * here and both modes update. Children are the mode-specific contents
 * (PhraseDisplay plus each mode's own controls).
 *
 * Any extra props (e.g. data-testid) are forwarded to the outer Card.
 */
export default function PhraseCard({ children, ...props }) {
    return (
        <Card className="bg-white border-stone-100 shadow-lg mb-8 overflow-hidden relative" {...props}>
            {/* Extra top-right padding reserves space for the absolute-positioned
                exit X and any corner controls, so long phrases can't wrap under them. */}
            {/* Left padding matches it for the back arrow on the left edge. */}
            <CardContent className="p-4 md:p-6 pt-8 pr-8 pl-8 md:pt-9 md:pr-9 md:pl-9">
                {children}
            </CardContent>
        </Card>
    );
}
